export default "__VITE_ASSET__CL9FN9YT__"